if (!customElements.get('cart-drawer-recently-viewed')) {
  customElements.define(
    'cart-drawer-recently-viewed',
    class CartDrawerRecentlyViewed extends HTMLElement {
      constructor() {
        super();
        this.loaded = false;
        this.limit = parseInt(this.dataset.limit || '6', 10);
        this.sectionId = this.dataset.sectionId || 'cart-drawer-recently-viewed';
        this.headingEl = this.querySelector('[data-heading]');
        this.listWrap = this.querySelector('[data-list]');
      }

      connectedCallback() {
        // Load on first idle so it doesn't block other resources
        if ('requestIdleCallback' in window) {
          requestIdleCallback(() => this.load(), { timeout: 2000 });
        } else {
          setTimeout(() => this.load(), 500);
        }
      }

      async getCartItemIds() {
        try {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const res = await fetch(`${root}cart.js`);
          if (!res.ok) return [];
          const data = await res.json();
          return (data.items || []).map((item) => item.product_id);
        } catch (_e) {
          return [];
        }
      }

      async getQueryUrl() {
        const stored = window.localStorage.getItem('sleektheme:recently-viewed');
        if (!stored) return null;
        let items;
        try {
          items = JSON.parse(stored);
        } catch (_e) {
          return null;
        }
        if (!Array.isArray(items) || items.length === 0) return null;

        // Filter out products already in cart
        const cartIds = await this.getCartItemIds();
        const filtered = items.filter((id) => !cartIds.includes(id));
        if (filtered.length === 0) return null;

        // Limit to recent N items
        const ids = filtered.slice(0, this.limit);
        const query = ids.map((id) => 'id:' + id).join(' OR ');
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        return `${root}search?section_id=${encodeURIComponent(this.sectionId)}&type=product&q=${encodeURIComponent(query)}`;
      }

      async load() {
        this.loaded = true;
        const url = await this.getQueryUrl();
        if (!url) {
          this.hide();
          return;
        }
        try {
          const response = await fetch(url);
          if (!response.ok) throw new Error('Network error');
          const text = await response.text();
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const fetched = doc.querySelector('.cart-recently-viewed');
          if (!fetched) { this.hide(); return; }
          const list = fetched.querySelector('.cart-recently-viewed__list');
          if (!list || !list.children.length || fetched.querySelector('[data-empty]')) {
            this.hide();
            return;
          }
          if (this.listWrap) {
            this.listWrap.innerHTML = '';
            this.listWrap.appendChild(list);
          }
          this.removeAttribute('hidden');
          // Hook quick-add forms to refresh cart instead of full page reload
          this.bindAddForms();
        } catch (e) {
          console.error('Recently viewed load failed', e);
          this.hide();
        }
      }

      hide() {
        this.setAttribute('hidden', '');
      }

      bindAddForms() {
        this.querySelectorAll('.cart-recently-viewed__form').forEach((form) => {
          form.addEventListener('submit', async (e) => {
            e.preventDefault();
            const btn = form.querySelector('button[name="add"]');
            if (!btn || btn.disabled) return;
            btn.disabled = true;
            btn.classList.add('is-loading');
            try {
              const formData = new FormData(form);
              const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
              const res = await fetch(`${root}cart/add.js`, {
                method: 'POST',
                body: formData,
                headers: { 'Accept': 'application/javascript' },
              });
              if (!res.ok) throw new Error('Add to cart failed');
              // Trigger Sleek's cart refresh — dispatch a custom event the theme listens for
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              // Fallback: reload cart drawer contents via section render API
              await this.refreshCart();
            } catch (err) {
              console.error(err);
            } finally {
              btn.disabled = false;
              btn.classList.remove('is-loading');
            }
          });
        });
      }

      async refreshCart() {
        try {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const res = await fetch(`${root}?sections=cart-drawer`);
          if (!res.ok) return;
          const data = await res.json();
          const html = data['cart-drawer'];
          if (!html) return;
          const newDrawer = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer');
          const existing = document.querySelector('cart-drawer');
          if (newDrawer && existing) {
            existing.innerHTML = newDrawer.innerHTML;
          }
        } catch (e) {
          console.error('Cart refresh failed', e);
        }
      }
    }
  );
}
